import React from "react";
import './EditControl.css';
import { navigateToCreate } from "utilities/js/NavigationHelper";
import { stickToFooter } from "utilities/js/styling/observerCreator";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import Constants from "utilities/js/Constants";

const EditIcon = Constants.ICON_EDIT;

class EditControl extends React.Component {

    constructor(props){
        super(props);
        this.state = {
        };

        this.navigateToCreate = this.navigateToCreate.bind(this);
    }

    componentDidMount(){
        // let element = document.querySelector('.edit-button-container');
        // stickToFooter(element, 0);
    }

    navigateToCreate(){
        if(this.props.isVisible && this.props.editId){
            navigateToCreate({bracketId:this.props.editId, routerNav: this.props.navigate})
        }
    }

    


    render(){
        if(this.props.isVisible){

            return (
                <div className="edit-button-container">
                    <div className="edit-button" onClick={this.navigateToCreate}><img className="edit-icon" alt="edit" src={EditIcon}></img></div>
                </div>
            );
        }else{
            return (
                <></>
            );
        }
    }
}

export default NavigatorWrapper(EditControl);
